// project imports
import { getIriFromObj, processDateFieldInput, processDateFieldOutput } from 'utils/processors';

export const processEntityInput = (values) => ({
    lockedAt: 'lockedAt' in (values || {}) ? processDateFieldInput(values.lockedAt) : null
});

export const processEntityOutput = (values) => ({
    lockedAt: 'lockedAt' in (values || {}) ? processDateFieldOutput(values.lockedAt, 'yyyy-MM-dd HH:mm') : undefined,
    lockedBy: 'lockedBy' in (values || {}) ? getIriFromObj(values?.lockedBy) : undefined
});
